export const ddrRegex = new RegExp('^(\\d{4}|\\d{8}|\\d{10})$');
